/*
 * @providesModule DateUtils
 *
 */

/* eslint-disable no-magic-numbers */

import I18n from 'INTL';
import moment from 'moment';

export const MINIMUM_AGE = 18;

export default class DateUtils {
  static ageWithin(userPersonalInfo: Object, ageVerifyProps: Object): boolean {
    if (userPersonalInfo && userPersonalInfo.birth_date) {
      const birthDate = userPersonalInfo.birth_date;
      const minimumAge = ageVerifyProps.minimumAge;
      const current = moment(Date.now());

      if (moment(current).isBefore(birthDate)) {
        return false;
      }

      const isAgeWithin = moment(birthDate).isBetween(
        moment(current).subtract(minimumAge, 'years'),
        current
      );
      return !isAgeWithin;
    } else {
      return false;
    }
  }

  static getFormattedDate(date: String): String {
    const localDate = moment(date);
    if (!localDate.isValid()) {
      return 'Invalid Date';
    }
    return localDate.format('LL');
  }

  static getFormattedDateWithoutYear(date: Date): String {
    const localDate = moment(date);
    if (!localDate.isValid()) {
      return 'Invalid Date';
    }
    const formatLL = moment.localeData().longDateFormat('LL');
    const formatYearlessLL = formatLL.replace(/Y/g, '').replace(/^\W|\W$|\W\W/, '');
    return localDate.format(formatYearlessLL);
  }

  static getNumericalDate(date: String): String {
    const localDate = moment(date);

    if (!localDate.isValid()) {
      return '00/00/00';
    }

    return localDate.format('L');
  }

  /**
   * minutesBetween calculates the difference between two dates in milliseconds
   *
   * @param {number} time1
   * @param {number} time2
   * @returns the time in munites between time1 and time2
   */
  static minutesBetween(time1: number, time2: number): number {
    const date1 = moment(time1);
    const date2 = moment(time2);

    if (!date1.isValid() || !date2.isValid()) {
      console.error('minutesBetween: invalid dates.', time1, time2);
      return -1;
    }

    return Math.abs(Math.floor(moment.duration(date1.diff(date2)).asMinutes()));
  }

  static getFormattedTimezone(date: Date): string {
    const momentDate = moment(date);

    if (!momentDate.isValid()) {
      console.error('getFormattedTimezone: invalid date.');
      return '';
    }
    return momentDate.format('Z');
  }

  static isFirstDateTimeBeforeSecond(date1: string, date2: string): boolean {
    const dateTime1 = moment(date1);
    const dateTime2 = moment(date2);

    return dateTime1.isBefore(dateTime2);
  }
}
